var map = {
	"./Animals-low.jpg": "9262",
	"./Books-low.jpg": "f53b",
	"./Drinks-low.jpg": "b53c",
	"./Education-low.jpg": "43a3",
	"./Entertainment-low.jpg": "758d",
	"./Fashion-low.jpg": "5829",
	"./Food-low.jpg": "55a0",
	"./Games-low.jpg": "25d6",
	"./Health&Fitness-low.jpg": "c6ff",
	"./Lifestyle-low.jpg": "08e5",
	"./Miscellaneous-low.jpg": "2168",
	"./Movies-low.jpg": "373e",
	"./Music-low.jpg": "356b",
	"./Occupation-low.jpg": "4b47",
	"./People-low.jpg": "bfe3",
	"./Science-low.jpg": "45c1",
	"./Sports-low.jpg": "a460",
	"./Television-low.jpg": "ebc3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1087";